import { createContext } from 'react';
import { SupportedLanguages } from 'models/languages';

export const LanguageContext = createContext<SupportedLanguages>('ko');
